<template>
  <div v-if="list.length > 0">
    <div class="pt-3 pl-3 pb-4" style="color: #212121; font-size: 18px; font-weight: 400">{{ title }}</div>
    <div
      v-for="(item) in list"
      :key="item.id"
      class="pa-2 search-results__item"
    >
      <v-row :class="'search-row ' + itemRowBackgroundId(item)" @click="handleClickRow(item)">
        <v-col cols="4" class="col-left">
          <p>{{ item.id }}</p>
          <p>{{ formatDateSlash(item.checkInDate)}}</p>
          <p>{{ item.facilityName }}</p>
        </v-col>
        <v-col cols="8" class="col-right">
          <p class="text-right">検索対象: {{ item.keywordHitIn }}</p>
          <p>{{ item.representativeName }}</p>
          <p :style="item.representativeName ? '' : 'margin-top: 20px;'">
            <span v-if="item.memberId">会員番号{{ item.memberId}}</span>
            <span v-if="item.clientId">{{ item.memberId ? ' ': ''}}顧客ID{{ item.clientId}}</span>
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { getBackgroundColorOfBookingTypeId } from '@/constants/contractColors'
import { formatDateSlash } from '@/constants/functions'

export default {
  props: {
    title: String,
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatDateSlash,
    handleClickRow (item) {
      window.open('/reservation/contract-detail?id=' + item.id + '&tab=basic-information', '_blank')
    },
    itemRowBackgroundId (item) {
      const bookingTypeId = item.bookingTypeId
      return getBackgroundColorOfBookingTypeId(bookingTypeId)
    }
  }
};
</script>

<style scoped lang="scss">
.search-results__item:not(:last-child) {
  border-bottom: solid 1px var(--border__white);
}
.search-row{
  cursor: pointer;
  .col-left{
    p{
      margin-bottom: 0;
      color: #000;
      &:nth-child(1){
        font-weight: 400;
        font-size: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      &:nth-child(2){
        font-weight: 400;
        font-size: 16px;
      }
      &:nth-child(3){
        font-weight: 400;
        font-size: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .col-right{
    p{
      margin-bottom: 0;
      color: #000;
      &:nth-child(2){
        font-size: 16px;
        overflow: hidden;
      }
      &:nth-child(2){
        font-weight: 400;
        font-size: 18px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      &:nth-child(3){
        font-weight: 400;
        font-size: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
</style>
